import { KeplrExtensionWallet } from "./extension";
import { KeplrMobileWallet } from "./mobile";
export const wallets = [KeplrExtensionWallet, KeplrMobileWallet];
//# sourceMappingURL=index.js.map